import React, { useContext } from "react";
import styles from "./Footer.module.css";
import { FaRegCopyright } from "react-icons/fa";
import { A } from "hookrouter";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <p>
        <FaRegCopyright /> Copyright Yazbie 2020
      </p>
      <div className={styles.links}>
        <A href={"/privacy"}>Privacy</A>

        <A href={"/terms"}>Terms</A>
      </div>
    </footer>
  );
};

export default Footer;
